import { api } from './baseApi';
export var recommendationListApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getRecommendationLists: builder.query({
                query: function (params) {
                    return ({
                        url: "/recommendation-lists",
                        method: 'GET',
                        params: params || {},
                    });
                },
                providesTags: ['RecommendationLists'],
            }),
            getRecommendationListsPublic: builder.query({
                query: function (params) {
                    return ({
                        url: '/recommendation-lists/public',
                        method: 'GET',
                        params: params || {},
                    });
                },
                providesTags: ['RecommendationLists'],
            }),
            getRecommendationListById: builder.query({
                query: function (id) {
                    return ({
                        url: "/recommendation-lists/".concat(id),
                        method: 'GET',
                    });
                },
                providesTags: function (result, error, id) { return [{ type: 'RecommendationLists', id: id }]; },
            }),
            createRecommendationList: builder.mutation({
                query: function (body) {
                    return ({
                        url: "/recommendation-lists",
                        method: 'POST',
                        body: body,
                    });
                },
                invalidatesTags: ['RecommendationLists'],
            }),
            updateRecommendationList: builder.mutation({
                query: function (_a) {
                    var id = _a.id, data = _a.data;
                    return ({
                        url: "/recommendation-lists/".concat(id),
                        method: 'PUT',
                        body: data,
                    });
                },
                invalidatesTags: function (result, error, _a) {
                    var id = _a.id;
                    return [{ type: 'RecommendationLists', id: id }];
                },
            }),
            // Новый эндпоинт для управления закрепленными ресторанами
            updatePinnedRestaurants: builder.mutation({
                query: function (_a) {
                    var id = _a.id, data = _a.data;
                    return ({
                        url: "/recommendation-lists/".concat(id, "/pinned-restaurants"),
                        method: 'PATCH',
                        body: data,
                    });
                },
                invalidatesTags: function (result, error, _a) {
                    var id = _a.id;
                    return [{ type: 'RecommendationLists', id: id }];
                },
            }),
            deleteRecommendationList: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/recommendation-lists/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['RecommendationLists'],
            }),
        });
    },
});
export var useGetRecommendationListsQuery = recommendationListApi.useGetRecommendationListsQuery, useGetRecommendationListsPublicQuery = recommendationListApi.useGetRecommendationListsPublicQuery, useGetRecommendationListByIdQuery = recommendationListApi.useGetRecommendationListByIdQuery, useCreateRecommendationListMutation = recommendationListApi.useCreateRecommendationListMutation, useUpdateRecommendationListMutation = recommendationListApi.useUpdateRecommendationListMutation, useUpdatePinnedRestaurantsMutation = recommendationListApi.useUpdatePinnedRestaurantsMutation, // Добавляем новый хук
useDeleteRecommendationListMutation = recommendationListApi.useDeleteRecommendationListMutation;
